import React from 'react';
import {Banner} from '@shopify/polaris';

export default function ComingSoon(){
    return <Banner status="info" title="Coming soon">
        Hey there!
        We are currently updating all of our apps and making sure it all works at its best.
        Thanks for your patience, we'll be back ASAP!
    </Banner>
}